import React, { FC } from 'react'
import { Helmet } from 'react-helmet'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'
import Header from '../components/Header'
import Login from '../containers/Login'
import MemberAccount from '../containers/MemberHome/Account'
import Members from '../containers/Admin/Members'
import AdminMember from '../containers/Admin/Member'
import Users from '../containers/Admin/Users'
import Developer from '../containers/Developer'
import ReleaseNotes from '../containers/ReleaseNotes'
import Register from '../containers/Register'
import Help from '../components/Help'
import Footer from '../components/Footer'
import Contact from '../containers/Contact'
import Account from '../components/Admin/Account'
import AccessDenied from '../components/AccessDenied'
import Providers from '../containers/Admin/Providers'
import Provider from '../containers/Admin/Provider'
import { companyMessage } from '../assets/i18n/i18n'
import TermsAndConditions from '../components/TermsAndConditions'
import Home from '../containers/Home'
import PageNotFound from '../containers/PageNotFound'
import AvailableApps from '../containers/AvailableApps'
import ProviderList from '../containers/ProviderList'
import { ContainerTitleProvider } from '../contexts/ContainerTitleContext'
import SessionTimeoutModal from '../components/Modals/SessionTimeoutModal'
import { appConfig } from '../assets/customizations/config'
import DrugLookup from '../containers/DrugLookup'
import useEnvironment from '../hooks/location/useEnviroment'
import DataSharing from '../containers/DataSharing'
import DeveloperRegistration from '../containers/DeveloperRegistration'
import PrivacyNotice from '../components/PrivacyNotice'
import NecessaryCookiesOnly from '../components/NecessaryCookiesOnly'
import CookieAcknowledgement from '../components/CookieAcknowledgement'


const Routes: FC = () => {
  const {
    data: environment
  } = useEnvironment()

  return (
    <>
      <Helmet>
        <title>{companyMessage.PreferedName} {companyMessage.DataPortalTitle}</title>
        <meta name='description' content={`${companyMessage.PreferedName} ${companyMessage.DataPortalTitle}`} />
      </Helmet>
      <Router>
        <Header />
        <SessionTimeoutModal />
        <main>
          <Switch>
            <Route
              exact
              path='/'
              render={(props) => <Home {...props} />}
            />
            <Route
              exact
              path='/my-account'
              render={props => <MemberAccount {...props} />}
            />
            <Route
              exact
              path='/data-sharing'
              component={DataSharing}
            />
            <Route
              exact
              path='/available-apps'
              component={AvailableApps}
            />
            <Route
              exact
              path='/members'
              render={props => <Members {...props} />}
            />
            <Route
              exact
              path='/provider-list/:page?/:resourceId?'
              render={props => (
                <ContainerTitleProvider title="Provider Directory">
                  <ProviderList {...props} />
                </ContainerTitleProvider>
              )}
            />
            <Route
              exact
              path='/providers'
              render={props => <Providers {...props} />}
            />
            <Route
              exact
              path='/provider/:providerId'
              component={Provider}
            />
            <Route
              exact
              path='/patient/:page?/:detailId?'
              render={props => (
                <ContainerTitleProvider title="Member Data">
                  <AdminMember {...props} />
                </ContainerTitleProvider>
              )}
            />
            <Route
              exact
              path='/accounts'
              component={Users}
            />
            <Route
              exact
              path='/account/:accountId'
              component={Account}
            />
            <Route
              exact
              path='/developers'
              component={appConfig.show_developers ? Developer : PageNotFound}
            />
            <Route
              exact
              path='/app-register'
              component={appConfig.show_developers ? DeveloperRegistration : PageNotFound}
            />
            <Route
              exact
              path='/drug-lookup'
              component={environment?.showDrugLookup ? DrugLookup : PageNotFound}
            />
            <Route
              exact
              path='/help'
              component={appConfig.show_help ? Help : PageNotFound}
            />
            <Route
              exact
              path='/terms'
              component={appConfig.show_terms ? TermsAndConditions : PageNotFound}
            />
            <Route
              exact
              path='/privacy'
              component={PrivacyNotice}
            />
            <Route
              exact
              path='/cookies'
              component={NecessaryCookiesOnly}
            />
            <Route
              exact
              path='/contact'
              component={Contact}
            />
            <Route
              exact
              path='/register/:step?'
              component={Register}
            />
            <Route
              exact
              path='/release-notes'
              component={ReleaseNotes} />
              
            <Route
              exact
              path='/login'
              component={Login}
            />
            <Route
              exact
              path='/access-denied'
              component={AccessDenied}
            />
            <Route path="/404" component={PageNotFound} />
            <Redirect to="/404" />
          </Switch>
        </main>
        <Footer />
        <CookieAcknowledgement />
      </Router>
    </>
  )
}

export default Routes